import React from 'react';

const Footer = () => {
  return (
    <>
      <footer>&copy;{new Date().getFullYear()} &nbsp;HaveYouWatched?</footer>
    </>
  );
};

export default Footer;
